import React, {FC} from "react"
import {WithDefaultTheme, withTheme} from "styled-components"

import {Label} from "@irati/ui/src/Typography"
import {Hr, Row, Col} from "@irati/ui/src/Layout"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage from "@irati/utils/lang"

interface Props extends WithDefaultTheme {}

const UnavailableDeal: FC<Props> = ({theme}) => {
  return (
    <>
      <Hr />
      <Row>
        <Col xs={12}>
          <Flex alignItems="center">
            <Icon icon={IconTypes.circleDisable} size={25} color={theme.colors.utility.ink} />
            <Label large display="inline-block" marginLeft>
              <FormattedMessage id="perks.components.importantInfoBlock.unavailableDeal.text" />
            </Label>
          </Flex>
        </Col>
      </Row>
    </>
  )
}

export default withTheme(UnavailableDeal)
